import { render, staticRenderFns } from "./UnitReceiptMonitoringWidget.vue?vue&type=template&id=3b81d22d&"
import script from "./UnitReceiptMonitoringWidget.vue?vue&type=script&lang=ts&"
export * from "./UnitReceiptMonitoringWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b81d22d')) {
      api.createRecord('3b81d22d', component.options)
    } else {
      api.reload('3b81d22d', component.options)
    }
    module.hot.accept("./UnitReceiptMonitoringWidget.vue?vue&type=template&id=3b81d22d&", function () {
      api.rerender('3b81d22d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UnitReceiptMonitoring/UnitReceiptMonitoringWidget.vue"
export default component.exports